import React, { useState, useEffect } from "react";
//import logo from '../logo.svg';
import '../App.css';
//import '../style.css';
import Lecture from "./Lecture";
import Search from "./Search";
import { BiArrowBack } from "react-icons/bi";

import content from "../content-qas-dict"

function App() {
  const [backBtn, setBackBtn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [lectures, setLectures] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showGroup, setShowGroup] = useState(true);
  const [searchTerm, setSearchTerm] = useState(null);
  const [searchKey, setSearchKey] = useState(1);
  const [tabState, setTabState] = useState(true)


  const handleCallback = childData => {
    console.log(childData)
    setSearchTerm(null)
    setBackBtn(true);
    setShowGroup(false);

    for(let i = 0; i < content["search"].length; i++) {
      if(content["search"][i]["display_question"] == childData[0]) {
        setLectures([content["search"][i]]);
      }
    }
  }
 
  const clickAllTab = function() {
    setTabState(false);
    reloadLectures();
  }

  const clickFeaturedTab = function() {
    setTabState(true)
    setSearchKey(searchKey + 1)
    setSearchTerm(null)
    setBackBtn(false);
    setErrorMessage(null);
    setShowGroup(true);

    let search_content = []

    for(let i = 0; i < content["search"].length; i++) {
      if(content["search"][i]["featured"]=="true") {
        search_content.push(content["search"][i])
      }
    }

    setLectures(search_content);
  }

  
  useEffect(() => {
    clickFeaturedTab();
    setLoading(false);
  }, []);
   
  
  const reloadLectures = allData => {
    setTabState(false);
    setSearchKey(searchKey + 1)
    setSearchTerm(null)
    setBackBtn(false);
    setErrorMessage(null);
    setShowGroup(true);
    setLectures(content["search"]);
  }

  const search = searchValue => {
    setShowGroup(true);
    setLoading(true);
    setBackBtn(true);
    setErrorMessage(null);

    console.log(`${searchValue}`)

    let search_content = []
    for(let i = 0; i < content["search"].length; i++) {
      let searchVal = `${searchValue}`
      searchVal = searchVal.toLowerCase()
      let featured = false;
      for(let j = 0; j < content["search"][i]["content"].length; j++) {
        if(content["search"][i]["content"][j].toLowerCase().includes(searchVal) && featured == false) {
          featured = true;
          let temp_search = {...content["search"][i]};
          search_content.push(temp_search)
        }
      }
    }

    setSearchTerm(searchValue)

    if(search_content.length > 0) {
      setLectures(search_content);
      setLoading(false);
    } else {
      setErrorMessage("No talks with that keyword available.");
      setLoading(false);
    }
  }


  return (
   <div className="App">
    <div className="header-container">
       <header onClick={clickFeaturedTab} className = "App-header">
         <h2><span>Larry Rosenberg: <span className="tagline">Four Decades of Wisdom</span></span></h2>
       </header>
       <div className={` header-description ${showGroup} `}>
          <h2>A repository for question and answers from Larry Rosenberg’s lectures & meditations</h2>
          <p>Below are questions from lectures and meditations Larry has given. Listen to them, or click to read a full transcript.</p>
          {(showGroup) ? <Search key={searchKey} search={search} /> : <p></p> }
       </div>
    </div>
    {(!backBtn) ?
    <div className="tabs">
      <div className={` tab featured ${tabState} `} onClick={clickFeaturedTab}>
        <p>Featured</p>
      </div>
      <div className={` tab all ${tabState} `}  onClick={ clickAllTab }>
        <p>All</p>
      </div>
    </div> : <div></div>
    }

    <div className={` Container ${showGroup} `}>
      <div className="messages">
        {(searchTerm) ? <p>Search Larry's Answers for: {searchTerm}</p> : <p></p> }
        {(backBtn && !tabState) ? <p className="backBtn" onClick={ reloadLectures }><BiArrowBack/> Back to All</p> : <p></p> }
        {(backBtn && tabState) ? <p className="backBtn" onClick={ clickFeaturedTab }><BiArrowBack/> Back to Featured</p> : <p></p> }
      </div>
      <div className="lectures">
        {loading && !errorMessage ? (
         <span>loading...</span>
         ) : errorMessage ? (
          <div className="errorMessage">{errorMessage}</div>
        ) : (
          lectures.map((lecture, index) => (
            <Lecture parentCallback = { handleCallback } showGroup={showGroup} setShowGroup={setShowGroup} key={`${index}-${lecture.display_name}`} lecture={lecture} />
          ))
        )}
      </div>
    </div>
  </div>
);
};

export default App;
